<template lang="html">
  <div class="shopify-create-store">
    <Guide
      :content="content"
      :contentVideo="contentVideo"
      contentHeading="Final Step - Save your ID"
      :closeLink="closeLink"
      :nextLink="closeLink"
      :previousLink="previousLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'AnalyticsSubmitDetails',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'analytics-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    previousLink() {
      return {
        name: 'analytics-submit-details',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
        <p>You should now see the <strong>Measurement ID</strong> for your stream. It looks similar to this:</p>

        <h2>G-6WK1TRN97Z</h2>

        <p>It may start with <strong>UA-</strong> if you have set up a Universal Analytics account.</p>

        <p>Copy and paste this unique ID in the <strong>Property/Measurement ID</strong> field on the next page to start tracking your visits.</p>

        <div class="helper-text">
          <p>You will be able to fill out the relevant information after proceeding this step. You can use your browsers back button if you need to revise this step.</p>
        </div>
        `
    },

    contentVideo() {
      return 'https://page-maker-pro.s3.eu-west-2.amazonaws.com/4+-+DIGITAT_SCREEN_02.mp4'
    }
  }
}
</script>

<style lang="sass">
  .shopify-guide
</style>
